import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { selectAppId } from 'core-components/sitebuilder/store/selectors/selectAppId'
import { Logic, Operator } from 'core-components/types'

import { getUserCrud } from '../helpers/getUserCrud'

export const useUserCrud = () => {
  const userCrud = getUserCrud()
  const appId = useSelector(selectAppId)

  useEffect(() => {
    userCrud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'Id',
          operator: Operator.CONTAINS,
          value: '@hp.com',
        },
        {
          field: 'AppId',
          operator: Operator.EQUAL,
          value: appId,
        },
      ],
    })
  }, [userCrud, appId])

  return userCrud
}
